export default __webpack_public_path__ + "static/media/tourist.269a45a6.png";